
import { useEffect, useState } from "react"
import DataFilter from "../../interface/resultContext/DataFilter"
import api from "../../services/api"

interface DayReport {
  qtdExit: number;
  qtdExitAutomatic: number;
  qtdLoss: number;
  priceUn: number;
  qtdPromotial: number;
  value: number
}

interface DayEntry {
  qtd: number;
  price: number;
}

interface Report {
  id: string;
  name: string;
  unit: string;
  priceTotal: number;
  days: Record<string, DayReport>;
  qtdExit: number;
  qtdExitAutomatic: number;
  qtdLoss: number;
  qtdPromotial: number
}

interface EntryCmv {
  id: string;
  name: string;
  unit: string;
  days: Record<string, DayEntry>;
  priceTotal: number;
  qtdTotal: number
}

interface Req {
  reports: Report[],
  entryCmv: EntryCmv[]
}

const useCmvHistory = (dataFilter: DataFilter) => {

  const [rows, setRows] = useState([])
  const [reports, setReports] = useState<Report[]>([])
  const [entry, setEntry] = useState<EntryCmv[]>([])
  const [loading, setloading] = useState(false)

  useEffect(() => {
    if (!dataFilter.estab) return;
    setloading(true);
    api.post<Req>('routes/cmvEntryHistory', dataFilter)
      .then((response) => {
        setReports(response.data.reports ?? [])
        setEntry(response.data.entryCmv ?? [])
      })
      .catch((e) => console.error('[API/cmvEntryHistory]:', e))
      .finally(() => setloading(false))

  }, [dataFilter])




  return { reports, loading, entry, rows };
}

export default useCmvHistory;